/**
 * This submodule handles ajax requests
 * and processes the data accordingly
 * --- Purpose ---
 * Handling ajax data flows
 * separate from the rest
 */
 define([],
    function () {
        const addToCartDataHandler = {
            URL: '/AjaxManageShoppingCartCmd',
            REQUEST_TYPE: 'POST',
            DATA_TYPE: 'json',

            /**
             * Simply makes the Ajax call with params given
             * @param {Object} serializedDataObject
             * @param {Object} formObject
             */
            makeAjaxCall: function (serializedDataObject, formObject) {
                $.ajax({
                    url: this.URL,
                    type: this.REQUEST_TYPE,
                    data: serializedDataObject,
                    dataType: this.DATA_TYPE,
                    success: function (data) {
                        addToCartDataHandler.validateSuccess(data, formObject, serializedDataObject);
                    },
                    error: function (data) {
                        console.log('error calling AjaxManageShoppingCartCmd');
                        console.log(data);
                        COSTCO.ExtendedAddToCart.ajaxErrorFlow(formObject, data, serializedDataObject);
                    },
                });
            },
            /**
             * Validates the success call
             * Checks for error messages in the API response
             * Redirects to proper flow
             * @param {Object} data
             * @param {Object} formObject
             * @param {Object} serializedDataObject
             */
            validateSuccess: function (data, formObject, serializedDataObject) {
                const orderErrMsgObj = data.orderErrMsgObj;
                const genericErrorMessage = data.errorMessage;
                const containsErrorMsgObj = orderErrMsgObj === undefined ? false : Object.values(orderErrMsgObj).length > 0;
                const containsGenericErrorMessage = genericErrorMessage !== undefined;
                if (!containsErrorMsgObj && !containsGenericErrorMessage) {
                    this.postSuccessStep(data, formObject, serializedDataObject);
                    COSTCO.ExtendedAddToCart.ajaxSuccessFlow(data, formObject, serializedDataObject);
                    if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true') {
	                    if (typeof contextVariables != 'undefined' && eval('typeof adobeProductData'+serializedDataObject.itemNumber) != 'undefined') {
		                    // If its successfully added to cart send Adobe event for the item
		                    contextVariables.orderId = data.orderId;
		                    let adobeProductData = eval('adobeProductData'+serializedDataObject.itemNumber);
		                    adobeProductData[0].product = $('#productTile_'+serializedDataObject.partNumber).attr('data-pdp-url');
		                    adobeProductData[0].quantity = parseInt(serializedDataObject.quantity);
		                    
		                    if( !($('#mymdGenericItemNumber').length > 0 && $('#mymdGenericItemNumber').val() == adobeProductData[0].SKU) ){
		                    	COSTCO.AdobeEvents.initEventIfLoggedIn('commerce.productListAdds', adobeProductData, adobeAnalyticsCommonData, contextVariables);
		                    }
	                    }
                    }
                } else {
                    COSTCO.ExtendedAddToCart.ajaxErrorFlow(data, formObject, serializedDataObject);
                }
            },
            /**
             * Inserts the orderItemId and orderId
             * into the form (for update calls)
             * @param {Object} data
             * @param {Object} formObject
             */
            postSuccessStep: function (data, formObject, serializedDataObject) {
                const orderItemId = $(formObject).find('.orderItemId');
                const orderId = $(formObject).find('.orderId');
                orderItemId.val(data.orderItemId);
                orderId.val(data.orderId);
                let qtyText = $(formObject).find('.product-quick-buy-txt .form-control');
                let price = $('#price-'+serializedDataObject.itemNumber).text().replace("$", "");
                let isFSACHDI = $('#productfsaChdAttr_'+serializedDataObject.partNumber).val();
                let updatedItemData = {
                    partNumber : serializedDataObject.itemNumber,
                    price : price,
                    quantity : qtyText.val(),
                    orderItemId : "",
                    isFSACHDI:isFSACHDI,
                    qtyBought: qtyText.val()
                };
                //update the cart indicator 
                $('body').trigger("costco.cart.item.added", [updatedItemData]);
            },

            buildAddToCartForm: function (settings) {
                if (settings.form != undefined){
                    let form = settings.form;
                }
                let event = settings.event;
                let index = settings.index;
                let partNumber = settings.partNumber;
                let sku = settings.sku;
                let contractIdentifier = settings.contractIdentifier;
                let actionType = settings.actionType;
                let quantity = settings.quantity;
                event.preventDefault();
                let target = event.target || event.srcElement;
                let $form = $(target).closest("form[name=OrderItemAddForm]");
                let fromPLP = settings.fromPLP;

                let isRestrictedPostalCode = COSTCO.Header.checkIsRestricted();
                //let $form = form ? $('#'+form) : $('#AddToCartForm-'+index),
                locale = COSTCO.util.getLocale(),
                    productErrorDiv = $form.find('.product-error').empty(),
                    quantity_text = messages.RWD_QUANTITY + ' ',
                    quantity,
                    formData = $form.serializeArray(),
                    cleanData = { 'ajaxFlag': true },
                    selected_products = [];
                cleanData = { 'ajaxFlag': true, 'checkOmsInventory': true, 'isRestrictedPostalCode': isRestrictedPostalCode, 'contractIdentifier': contractIdentifier, 'fromPLP': fromPLP };
                cleanData['quantity'] = quantity;

                cleanData['actionType'] = actionType;
                let formData = $form.serializeArray();
                $.each(formData, function (index, value) {
                    let dataName = formData[index].name;
                    let dataValue = formData[index].value;

                    if (!/_\d$/.test(dataName) && dataValue !== '' && dataValue !== '0') {
                        cleanData[dataName] = dataValue;
                    }
                });
                let orderItemId = $form.find('#orderItemId-' + index).val();

                if (orderItemId != undefined && orderItemId != '' && orderItemId != null) {
                    cleanData['orderItemId'] = orderItemId;
                    let orderId = $form.find('#orderId').val();

                    if (orderId != undefined || orderId != '') {
                        cleanData['orderId'] = orderId;
                    }
                }
                let productIndex = 1;

                cleanData['quantity_' + productIndex] = quantity;
                cleanData['orderItemId_' + productIndex] = cleanData['orderItemId'];
                if (actionType == 'update')
                    cleanData['orderItem_' + productIndex] = cleanData['orderItemId'];
                cleanData['itemNumber'] = sku;
                cleanData['partNumber'] = partNumber;
                cleanData['quantity'] = quantity;
                cleanData['catalogEntryId_' + productIndex] = cleanData['catEntryId'];

                //needed to check for merchandising association for quick add to cart
                cleanData['isQuickAddToCartButton'] = $('#addButtonContainer-' + index).is(':visible');
                return cleanData;
            },
        };
        return addToCartDataHandler;
    });



// WEBPACK FOOTER //
// ./js/search/addToCartDataHandler.js